import api from '@/shared/api/api';
import { Billing } from '@/shared/api/protocol-ts/api/billing_new/svc_billing_new_connectweb';
import {
  CreateOrderReq,
  CreateOrderResp,
  GetAvailableProductsReq,
  GetAvailableProductsResp,
  PayOrderReq,
  PayOrderResp,
  SetAccountBillingInformationReq,
  SetAccountBillingInformationResp,
  ListDiagnocoinLedgerReq,
  ListDiagnocoinLedgerResp,
  SetAccountSettingsReq,
  SetAccountSettingsResp,
} from '@/shared/api/protocol-ts/api/billing_new/svc_billing_new_pb';
import { SliceName } from '@/shared/config';
import { createThunkGenerator } from '@/shared/lib';

type BillingRequests = keyof typeof Billing.methods;

const generateBillingThunk = createThunkGenerator<BillingRequests>(
  SliceName.billing,
);

export const setAccountBillingInformation = generateBillingThunk<
  SetAccountBillingInformationReq,
  SetAccountBillingInformationResp
>('setAccountBillingInformation', api.billing.setAccountBillingInformation);

export const getAvailableProducts = generateBillingThunk<
  GetAvailableProductsReq,
  GetAvailableProductsResp
>('getAvailableProducts', api.billing.getAvailableProducts);

export const payOrder = generateBillingThunk<PayOrderReq, PayOrderResp>(
  'payOrder',
  api.billing.payOrder,
);

export const createOrder = generateBillingThunk<
  CreateOrderReq,
  CreateOrderResp
>('createOrder', api.billing.createOrder);

export const setAccountSettings = generateBillingThunk<
  SetAccountSettingsReq,
  SetAccountSettingsResp
>('setAccountSettings', api.billing.setAccountSettings);

export const listDiagnocoinLedger = generateBillingThunk<
  ListDiagnocoinLedgerReq,
  ListDiagnocoinLedgerResp
>('listDiagnocoinLedger', api.billing.listDiagnocoinLedger);
